// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/Divider.js with go/sail-next-tailor-docs-publisher 

import React from 'react';
import { Divider, view, css } from '@sail/ui';

const Container = ({
  children
}) => <view.div css={{
  width: css.value('300px'),
  background: 'surface',
  padding: 'medium',
  borderRadius: 'large',
  layout: 'column'
}}>
    {children}
  </view.div>;

const basic = {
  rendered: <Container>
      <Divider />
    </Container>,
  source: `<Divider />`
};
export const DividerExamples = {
  basic
};